import { Link } from "react-router-dom";

export type Crumb = { label: string; to?: string };

const Breadcrumb = ({ items }: { items: Crumb[] }) => (
  <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
    {items.map((item, index) => (
      <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
        {index > 0 ? <span className="text-background-400">/</span> : null}
        {item.to ? (
          <Link to={item.to} className="transition-colors hover:text-primary-600">
            {item.label}
          </Link>
        ) : (
          <span className="text-foreground-800">{item.label}</span>
        )}
      </span>
    ))}
  </nav>
);

export default Breadcrumb;